import gsap from 'gsap'

/** Aligné sur $mobile (769px) dans _variables.scss — mobile = max-width 768px */
export const MOBILE_MQ = '(max-width: 768px)'

export let reduceMotion = false

export class ReducedMotion {
  constructor () {
    const mm = gsap.matchMedia()

    mm.add(`(prefers-reduced-motion: reduce), ${MOBILE_MQ}`, () => {
      reduceMotion = true
      document.documentElement.classList.add('reduce-motion')

      return () => {
        reduceMotion = false
        document.documentElement.classList.remove('reduce-motion')
      }
    })
  }
}
